module.exports = __webpack_public_path__ + "static/SquareSerif-Bold-webfont-c4cc7a3a1de523928b3058a8a5b61d51.woff2";